import { render } from "./UiWineWarning.vue?vue&type=template&id=48d45aa4&scoped=true"
import script from "./UiWineWarning.vue?vue&type=script&lang=js"
export * from "./UiWineWarning.vue?vue&type=script&lang=js"

import "./UiWineWarning.vue?vue&type=style&index=0&id=48d45aa4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-48d45aa4"

export default script